export const environment = {
  production: false,
  apiUrl: 'https://backend.lacalderapadel.site/api/v1',
};
